import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload/index";
import LivestreamBackground from "../LivestreamBackground";
import cn from "classnames";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";

// 1300×650 — Email banner livestream card (Figma 4289:2194).
// Centered title, a small round avatar upload + speaker name. No date/job.
const LivestreamEmail = ({id, zoom}) => {
  const {titles, names, names2, names3, names4, names5, names6} = useEdits();
  const {layoutOption, titleFontSize} = useSetting();
  const isL3 = Number(layoutOption) === 3;
  const isL4 = Number(layoutOption) === 4;
  const isL5 = Number(layoutOption) === 5;
  const isL6 = Number(layoutOption) === 6;
  const isL7 = Number(layoutOption) === 7;
  const title = titles[id] || titles.main;
  const name = names[id] || names.main;
  const name2 = names2[id] || names2.main;
  const name3 = names3[id] || names3.main;
  const name4 = names4[id] || names4.main;
  const name5 = names5[id] || names5.main;
  const name6 = names6[id] || names6.main;

  return (
    <div
      id={id}
      className={`template livestream livestream-tpl layout-${layoutOption}`}
      style={{"--zoom-level": zoom}}
    >
      <div className="livestream-tpl__inner">
        <LivestreamBackground id={id} />

        <div className="content">
          <h1 className={cn("title", {"title--small": titleFontSize === "small"})}>
            <Textarea id={id} text={title} />
          </h1>

          {isL4 || isL5 || isL6 || isL7 ? (
            // layout-4/5/6/7: three/four/five/six host names inline, centered (no photos).
            <div className="ls-names">
              <h2 className="name">
                <Textarea id={id} text={name} inline />
              </h2>
              <span className="ls-sep">, </span>
              <h2 className="name2">
                <Textarea id={id} text={name2} inline />
              </h2>
              <span className="ls-sep">, </span>
              <h2 className="name3">
                <Textarea id={id} text={name3} inline />
              </h2>
              {(isL5 || isL6 || isL7) && (
                <>
                  <span className="ls-sep">, </span>
                  <h2 className="name4">
                    <Textarea id={id} text={name4} inline />
                  </h2>
                </>
              )}
              {(isL6 || isL7) && (
                <>
                  <span className="ls-sep">, </span>
                  <h2 className="name5">
                    <Textarea id={id} text={name5} inline />
                  </h2>
                </>
              )}
              {isL7 && (
                <>
                  <span className="ls-sep">, </span>
                  <h2 className="name6">
                    <Textarea id={id} text={name6} inline />
                  </h2>
                </>
              )}
            </div>
          ) : isL3 ? (
            <div className="ls-speakers">
              <div className="ls-card">
                <div className="upload-wrap upload-a">
                  <ImageUpload
                    isMini={true}
                    id="ls-speaker-1"
                    imageKey="ls-speaker-1"
                    transformKey={`${id}-ls-speaker-1`}
                  />
                </div>
                <h2 className="name">
                  <Textarea id={id} text={name} />
                </h2>
              </div>
              <div className="ls-card">
                <div className="upload-wrap upload-b">
                  <ImageUpload
                    isMini={true}
                    id="ls-speaker-2"
                    imageKey="ls-speaker-2"
                    transformKey={`${id}-ls-speaker-2`}
                  />
                </div>
                <h2 className="name2">
                  <Textarea id={id} text={name2} />
                </h2>
              </div>
            </div>
          ) : (
            <h2 className="name">
              <Textarea id={id} text={name} />
            </h2>
          )}
        </div>

        {!isL3 && !isL4 && !isL5 && !isL6 && !isL7 && (
          <div className="upload-wrap">
            <ImageUpload isMini={true} id={id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LivestreamEmail;
